"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Section10_1 = __importDefault(require("./Section10"));
exports.Section10 = Section10_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9pbnRlbGxpdGVjL0Vucm9sbGVtbnRQYWNrZXRJbmZvL3BhcnRzL1NlY3Rpb24xMC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDBEQUFtQztBQUMzQixvQkFERCxtQkFBUyxDQUNDIn0=